var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMercleWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 18,
    viewBox: "0 0 98 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5151_22737",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 98,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.219 0H0V18H97.219V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5151_22737)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9825 0V7.58158H6.24219V0H10.9825Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5278 3.5625V8.56994H0V3.5625H15.5278Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.70763 7.35156C12.7151 9.0499 15.5332 13.0219 15.5332 17.6414H10.5257C10.5257 15.2114 9.11115 13.1051 7.0625 12.1018",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.17 6.47168H6.16259C6.16259 9.86947 3.3978 12.6343 0 12.6343V17.6418C6.15816 17.6418 11.1689 12.632 11.1689 6.47278L11.17 6.47168Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.9533 11.5659L94.2177 8.88089C93.3397 6.80674 90.9219 5.88551 88.8677 6.55288C86.9055 7.19031 85.4377 9.34871 85.9533 11.5659ZM97.1389 9.93958L86.543 13.3828C87.7758 15.2918 89.8964 16.0833 91.8587 15.4459C93.3586 14.9581 94.5159 13.7287 94.8197 12.149L97.2209 11.3686C97.069 14.2796 95.2143 16.7397 92.4673 17.632C88.8666 18.8016 84.94 16.6143 83.8481 13.2542C82.5577 9.28109 84.7039 5.52079 88.0972 4.41886C91.8598 3.19609 95.6523 5.12725 96.824 8.73678C96.9493 9.12256 97.0679 9.48617 97.1389 9.93958Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.9586 17.6652H79.4766V0H81.9586V17.6652Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4891 13.2967H78.2583C77.2075 16.281 74.6777 17.9993 71.741 17.9993C67.9452 17.9993 64.9609 14.944 64.9609 11.1715C64.9609 7.18508 67.8499 4.08105 71.7167 4.08105C74.7243 4.08105 77.4702 5.96675 78.2583 8.83132H75.5136C74.773 7.27931 73.579 6.3481 71.7887 6.3481C69.1869 6.3481 67.4442 8.32913 67.4442 11.0274C67.4442 13.7256 69.2345 15.7301 71.741 15.7301C73.436 15.7301 74.7962 14.8232 75.4891 13.2956V13.2967Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.9988 17.6656H58.5156V4.44023H60.8314V5.54549C60.8314 5.56433 60.8458 5.57874 60.8647 5.57874C60.8735 5.57874 60.8824 5.57541 60.889 5.56766C61.9821 4.40919 63.4122 4.08105 65.186 4.08105V6.63522C62.7969 6.63522 60.9977 7.00327 60.9977 10.2403V17.6645L60.9988 17.6656Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.1305 11.5794L54.2586 8.93874C53.3839 6.86348 50.9971 5.93227 48.9773 6.58855C47.0474 7.21601 45.6106 9.36333 46.1305 11.5794ZM57.142 10.0096L46.7213 13.3953C47.9452 15.3064 50.0372 16.108 51.9672 15.4804C53.4427 15.0004 54.5768 13.7788 54.8684 12.2035L57.2296 11.4364C57.0944 14.3419 55.2785 16.7886 52.5769 17.6665C49.035 18.8173 45.1561 16.6134 44.0652 13.2533C42.7737 9.28018 44.8712 5.53651 48.2092 4.45232C51.9095 3.24952 55.6543 5.19617 56.8272 8.80571C56.9524 9.1915 57.0711 9.55511 57.1431 10.0085L57.142 10.0096Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.341 17.6897H20.7891L25.0215 6.49528C25.5493 4.95879 26.4217 4.00431 28.2453 4.00431C30.2729 4.00431 31.2851 5.18051 31.2851 6.93095V14.8795C31.2851 15.3373 31.5699 15.6344 31.9724 15.6344C32.3382 15.6344 32.622 15.416 32.7406 15.0757L36.0641 6.49195C36.5918 4.95989 37.4599 4.00098 39.2845 4.00098C41.3121 4.00098 42.3243 5.17718 42.3243 6.92763V17.6831H39.9132V7.04957C39.9132 6.57067 39.6282 6.27245 39.2225 6.27245C38.8788 6.27245 38.595 6.51191 38.4731 6.85003L35.1496 15.4337C34.6218 16.9658 33.7317 17.9247 31.907 17.9247C29.9016 17.9247 28.8894 16.7485 28.8894 14.9759V7.04957C28.8894 6.57067 28.5868 6.27245 28.18 6.27245C27.8141 6.27245 27.5702 6.51191 27.4305 6.85003L23.3388 17.6853L23.3421 17.6886L23.341 17.6897Z",
    fill: "white",
    fillOpacity: 0.9
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMercleWhite);
export default __webpack_public_path__ + "static/media/mercle_white.c2501cae5e651c99c590d053d217b8c7.svg";
export { ForwardRef as ReactComponent };